<!-- eslint-disable vue/no-v-model-argument -->
<template>
  <div class="dashboard-container">
    <div class="titleArea" v-show="dashboard && dashboard.dashboardId">
      <c-label ellipsis :weight="700" :size="24">
        {{ dashboard && dashboard.dashboardName }}</c-label
      >
      <div class="action">
        <ScpmReloadDatePicker
          ref="reloadPicker"
          isDashboard
          :refreshPlay="searchDateDashboard.isRefreshPlay"
          :defaultValue="searchDateDashboard.tab1value"
          :dateTime="searchDateDashboard"
          @refresh="refresh"
          @save="refresh"
        />
        <div
          class="buttonGroup"
          v-if="dashboardActiveTab == 'my' && dashboard && dashboard.dashboardId"
        >
          <lego-icon-button
            icon="add"
            iconType="picto"
            @click="togglePopup('addWidget')"
            primary
            v-lego-tooltip="$t('page.dashboard.Addwidget')"
          />
          <lego-drop-holder
            :items="[
              { value: 'update', text: $t('page.dashboard.editDashboard') },
              { value: 'copy', text: $t('page.dashboard.copyDashboard') },
              { value: 'share', text: $t('page.dashboard.shareDashboard') },
              { value: 'delete', text: $t('page.dashboard.deleteDashboard') }
            ]"
            menuDirection="right"
            itemWidth="140"
            @click="dashboardMenuClick"
          >
            <lego-icon-button icon="more" iconType="df" lange primary color="red" />
          </lego-drop-holder>
        </div>
      </div>
    </div>
    <grid-layout
      v-if="layout.length > 0"
      v-model:layout="layout"
      :col-num="8"
      :row-height="137"
      :margin="[22, 22]"
      :is-draggable="true"
      :is-resizable="true"
      :vertical-compact="true"
      :use-css-transforms="true"
      @layout-updated="layoutUpdated"
    >
      <grid-item
        v-for="item in layout"
        :x="item.x"
        :y="item.y"
        :w="item.w"
        :h="item.h"
        :minW="item.chartAttr.minW"
        :maxW="item.chartAttr.maxW"
        :minH="item.chartAttr.minH"
        :maxH="item.chartAttr.maxH"
        :isDraggable="dashboardActiveTab == 'share' ? false : item.chartAttr.isDraggable"
        :isResizable="dashboardActiveTab == 'share' ? false : item.chartAttr.isResizable"
        :static="dashboardActiveTab == 'share' ? false : item.chartAttr.static"
        :i="item.i"
        drag-allow-from=".vue-draggable-handle"
        drag-ignore-from=".no-drag"
        :key="item.i"
        @resize="resizeEvent"
        @resized="resizedEvent"
        @move="moveEvent"
        @moved="movedEvent"
        :class="renderClassGridItem(item)"
      >
        <div class="box">
          <div class="box-header vue-draggable-handle"></div>
          <div class="content">
            <div style="width: 100%; height: 100%">
              <component
                :is="item.chartAttr.widget.type"
                :excludeResources="excludeResources"
                :configItem="item"
                @widgetCtrl="widgetCtrl"
                :sharedDashboard="dashboardActiveTab == 'share'"
                :searchDate="searchDate"
                @popup="onClickPopup"
                :isCustomDashboard="true"
              />
            </div>
          </div>
        </div>
      </grid-item>
    </grid-layout>
    <div
      v-show="layout.length < 1 && dashboard && dashboard.dashboardId && !getWidgetLoading"
      class="emptyWedget"
    >
      <img src="@/assets/img/dashboard/noWidget.png" />
      <div class="noWidgetMessage">{{ $t('page.dashboard.noWidgets') }}</div>
      <div class="makeWidgetMessage">{{ $t('page.dashboard.configDashboard') }}</div>
      <lego-button v-if="dashboardActiveTab === 'my'" @click="togglePopup('addWidget')" main large
        >{{ $t('page.dashboard.Addwidget') }}
      </lego-button>
    </div>
    <div
      v-show="layout.length < 1 && (!dashboard || !dashboard.dashboardId)"
      class="emptyWedget emptyWedget--notDashboard"
    >
      <img src="@/assets/img/dashboard/noWidget.png" />
      <div class="noWidgetMessage">
        {{
          dashboardActiveTab === 'my'
            ? $t('page.dashboard.noSelectedDashboard')
            : $t('page.dashboard.noSelectedShareDashboard')
        }}
      </div>
      <lego-button v-if="dashboardActiveTab === 'my'" @click="dashboardAdd" main large
        >{{ $t('page.dashboard.addDashboard') }}
      </lego-button>
    </div>
    <AddWidgetPopup
      v-if="popup.addWidget"
      @close="togglePopup('addWidget')"
      :searchDate="searchDate"
      @widgetAdd="onWidgetAdd"
      @widgetCount="onWidgetCount"
    />
    <EditWidgetPopup
      v-if="popup.editWidget"
      @close="togglePopup('editWidget')"
      :config="popup.editConfig"
      :searchDate="searchDate"
      @widgetCtrl="widgetCtrl"
    />
    <WidegtCopyPopup
      v-if="popup.copyWidget"
      @close="togglePopup('copyWidget')"
      :widgetNames="widgetNames"
      :config="popup.editConfig"
      @copyWidget="onWidgetCopy"
    />
    <WidegtDeletePopup
      v-if="popup.deleteWidget"
      @close="togglePopup('deleteWidget')"
      @deleteWidget="onWidgetDelete"
    />
    <MonTargetDetailPopup
      v-if="popup.monTargetDetail"
      :params="monitoringModalParam"
      isDashboard
      :refreshPlay="searchDateDashboard.isRefreshPlay"
      :dateTime="searchDateDashboard"
      :defaultValue="searchDateDashboard.tab1value"
      @close="togglePopup('monTargetDetail')"
    ></MonTargetDetailPopup>
  </div>
</template>

<script>
import i18nMixin from '@/mixins/i18n.mixin.js';
import { GridLayout, GridItem } from 'vue-grid-layout-v3'; // 대시보드 라이브러리
import ScpmReloadDatePicker from '@/components/scpm/components/scpmReloadDatePicker/scpmReloadDatePicker';
import legoEventBus from '@/lego-component/utils/eventBus/eventBus';

import AddWidgetPopup from '@/containers/widget/AddWidgetPopup.vue'; // 위젯 추가 팝업
import EditWidgetPopup from '@/containers/widget/EditWidgetPopup.vue'; // 위젯 수정 팝업
import WidegtCopyPopup from './WidegtCopyPopup'; // 위젯 복사 팝업
import WidegtDeletePopup from './WidegtDeletePopup'; // 위젯 삭제 팝업

// 대시보드에서 사용하는 위젯들.
import TitleBoxWidget from '../widget/components/TitleBoxWidget';
import EventStausWidget from '../widget/components/EventStausWidget';
import MonitoringStatusWidget from '../widget/components/MonitoringStatusWidget';
import PerfermanceTop5Widget from '../widget/components/PerfermanceTop5Widget';
import EventMapWidget from '../widget/components/EventMapWidget';
import EventHistoryWidget from '../widget/components/EventHistoryWidget';
import TimeSeriesGraphWidget from '../widget/components/TimeSeriesGraphWidget';
import StatusMetricWidget from '../widget/components/StatusMetricWidget';
import InstanceMapWidget from '../widget/components/InstanceMapWidget';
import MonTargetDetailPopup from '@/containers/popup/MonTargetDetailPopup.vue';
import { mapActions, mapState } from 'vuex';
import { cloneDeep } from 'lodash';
import { GLOBAL_CDN } from '@/containers/utils/constant';

export default {
  components: {
    GridLayout,
    GridItem,
    AddWidgetPopup,
    EditWidgetPopup,
    WidegtCopyPopup,
    WidegtDeletePopup,
    TitleBoxWidget,
    EventStausWidget,
    MonitoringStatusWidget,
    PerfermanceTop5Widget,
    EventMapWidget,
    EventHistoryWidget,
    TimeSeriesGraphWidget,
    StatusMetricWidget,
    InstanceMapWidget,
    ScpmReloadDatePicker,
    MonTargetDetailPopup
  },
  mixins: [i18nMixin],
  data() {
    return {
      now: '', // 우측 타이머 표기용
      timer: {}, // 타이머 인터벌 객체 저장
      popup: {
        addWidget: false, // 위젯 추가 팝업
        editWidget: false, // 위젯 수정 팝업
        copyWidget: false, // 위젯 복사 팝업
        deleteWidget: false, // 위젯 삭제 확인 팝업
        editConfig: {}, // 위젯 수정, 복사시 설정 전달용
        monTargetDetail: false // 모니터링 상세 팝업
      },
      isDropdownRefresh: false, // 리플래시 설정 드롭다운
      isRefreshPlay: false, // 자동 리플래시
      layout: [], // 위젯들 목록
      index: '0', // 레이아웃 내의 위젯의 인덱스
      layoutLoaded: false, // 위젯 정보 갱신중 중복 작용 방지용
      seq: 0, // 위젯 추가시 시퀀스
      widgetCount: 0, // 위젯 다중 추가시 최대 위젯수
      added: 0, // 위젯 다중 추가시 로딩 타이밍 제어용 카운터
      toDeleteWidget: {}, // 위젯 삭제시 설정 전달용
      widgetNames: [], // 위젯명 중복 검사용 목록
      loading: false, // 연속 새로고침 방지용 로딩
      getWidgetLoading: false, // 위젯들 로딩 완료여부 확인
      searchDate: {}, // 위젯 검색 시간,
      monitoringModalParam: null, // 모니터링 상세 팝업 params
      excludeResources: [GLOBAL_CDN]
    };
  },
  watch: {
    layout: {
      // layout 변경시 위젯의 인덱스 계산
      handler() {
        this.index = Math.max(...this.layout.map((o) => Number(o.i) + 1), 0).toString();
        this.widgetNames = this.layout.map((w) => w.chartAttr.subtitle);
      }
    },
    dashboard() {
      // 대시보드 선택시 위젯 로딩.
      this.layoutLoaded = false;
      if (this.dashboard && this.dashboard.dashboardId) {
        this.getListWidgets();
      } else {
        this.layout = [];
      }
    },
    widgetRefresh() {
      // 위잿 갱신 요청시 갱신함수 실행
      if (this.widgetRefresh) {
        this.refresh();
      }
    }
  },
  computed: {
    ...mapState(['dashboard', 'dashboardActiveTab']),
    ...mapState({
      searchDateDashboard: (state) => state.dashboardState.searchDateDashboard
    }),
    dashboardActiveMenu: {
      get() {
        return this.$store.state.dashboardActiveMenu;
      },
      set(dashboardActiveMenu) {
        this.$store.commit('setDashboardActiveMenu', dashboardActiveMenu);
      }
    },
    widgetRefresh: {
      // 위젯 갱신 활성화 store에 연결
      get() {
        return this.$store.state.widgetRefresh;
      },
      set(widgetRefresh) {
        this.$store.commit('setWidgetRefresh', widgetRefresh);
      }
    }
  },
  mounted() {
    legoEventBus.$on('open-modal', (isShow) => {
      this.$nextTick(() => {
        if (this.$refs.reloadPicker) {
          if (isShow) {
            this.$refs.reloadPicker.onPause();
          } else {
            this.$refs.reloadPicker.onStart();
          }
        }
      });
    });
    this.$store.dispatch('notify/stopFetchingNotification');
    this.setSearchDate();
  },
  beforeUnmount() {
    legoEventBus.$off('open-modal');
  },
  methods: {
    ...mapActions('dashboardState', ['setSearchDateDashboard']),
    renderClassGridItem(grid) {
      const lstClasses = {
        MonitoringStatusWidget: 'monitoring-status-widget',
        StatusMetricWidget: `wrap-status-metric-widget auto-${grid.w}`
      };
      return lstClasses[grid.chartAttr.widget.type] || '';
    },
    startLoading() {
      // 로딩시작
      this.$store.commit('setLoading', true);
    },
    endLoading() {
      // 1초후 로딩아이콘 해제
      window.setTimeout(() => {
        this.$store.commit('setLoading', false);
      }, 1000);
    },
    refresh() {
      // 위젯 데이터 새로고침.
      if (this.popup.monTargetDetail || !this.dashboard || !this.dashboard.dashboardId) {
        return;
      }
      this.setSearchDate();
      if (!this.loading) {
        if (this.layout.length === 0) {
          this.startLoading();
          this.endLoading();
        } else {
          this.layout = this.layout.map((d) => {
            d.i = d.i + this.index;
            return d;
          });
        }
      }
      this.loading = true;
      window.setTimeout(() => {
        this.loading = false;
      }, 4000);
    },
    getSeq() {
      // 위젯 등록시 순번생성용
      return ++this.seq;
    },
    async widgetCtrl(ctrlObj) {
      // 위젯 삭제,수정,수정완료,복사 기능 처리.
      if (ctrlObj.type === 'delete') {
        this.toDeleteWidget = ctrlObj.config;
        this.togglePopup('deleteWidget');
      } else if (ctrlObj.type === 'modify') {
        this.popup.editConfig = ctrlObj.config;
        this.togglePopup('editWidget');
      } else if (ctrlObj.type === 'modified') {
        let config = this.$util.deepCopy(ctrlObj).config;

        if (config.chartType === 'TitleBoxWidget') {
          const newWidth = this.calculateSizeWidget(ctrlObj.config);
          if (newWidth !== false) config.w = newWidth;
        }

        config.chartAttr.h = config.h;
        config.chartAttr.w = config.w;
        config.chartAttr.x = config.x;
        config.chartAttr.y = config.y;
        delete config.x;
        delete config.y;
        delete config.w;
        delete config.h;
        delete config.i;

        await this.updateWidget(config, true).then(() => {
          this.getListWidgets();
        });
      } else if (ctrlObj.type === 'copy') {
        this.popup.editConfig = ctrlObj.config;
        this.togglePopup('copyWidget');
      }
    },
    onWidgetCount(n) {
      // 위젯 동시 다수 등록시 카운트 초기화
      this.widgetCount = n;
      this.added = 0;
    },
    onWidgetDelete() {
      // 위젯 삭제 확인 이벤트 처리
      this.deleteWidget(this.toDeleteWidget);
    },
    async onWidgetCopy(config) {
      this.copyWidget(config);
    },
    dashboardMenuClick(a) {
      // 대시보드 메뉴 클릭 =>> dashboard lnb쪽으로 팝업 오픈 전달.
      this.dashboardActiveMenu = a.value;
    },
    dashboardAdd() {
      // 대시보드 추가 => dashboard lnb쪽으로 대시보드 추가 팝업 오픈 전달.
      this.dashboardActiveMenu = 'add';
    },
    togglePopup(id) {
      // 위젯 관련 팝업 열기/닫기
      this.popup[id] = !this.popup[id];
    },
    async onWidgetAdd(widgets) {
      // 위젯 추가
      const y =
        this.layout.length === 0
          ? 1
          : this.layout.map((o) => Number(o.y) + Number(o.h)).sort((a, b) => a - b)[
              this.layout.length - 1
            ] + 1;
      widgets.forEach((config, i) => {
        config.chartAttr.x = 0;
        config.chartAttr.y = Number(y || 0) + Number(config.chartAttr.h) * i;
        config.chartType = config.chartAttr.widget.type;
        config.chartName = config.chartAttr.widget.type + Date.now() + this.getSeq();
        this.createWidget(config);
      });
    },
    resizeEvent(i) {
      // 사이즈 조정 이벤트 처리
      this.loading = true;

      this.layout.forEach((widget) => {
        if (widget.i === i) {
          widget.chartAttr.x = widget.x;
          widget.chartAttr.y = widget.y;
          widget.chartAttr.w = widget.w;
          widget.chartAttr.h = widget.h;
        }
      });
    },
    moveEvent() {
      this.loading = true;
    },

    getMaxWidthOfTitle(title = '') {
      let maxWidth = 0;
      if (!title) return maxWidth;
      const tempElement = document.createElement('span');
      tempElement.style.visibility = 'hidden';
      tempElement.style.position = 'absolute';
      tempElement.style.whiteSpace = 'nowrap';
      tempElement.style.fontSize = '16px';
      tempElement.style.fontWeight = 400;
      tempElement.textContent = title;
      document.body.appendChild(tempElement);
      maxWidth = tempElement.offsetWidth + 40;
      document.body.removeChild(tempElement);
      return maxWidth;
    },

    calculateSizeWidget(configWidget) {
      const config = this.$util.deepCopy(configWidget);
      const fixWidth = 172;
      const maxWidth = this.getMaxWidthOfTitle(config.chartAttr.title);

      const w = config.w;
      const line = Math.ceil(maxWidth / (fixWidth * w));
      if (line >= 3 && config.h <= 2 && config.w <= 2) {
        return config.w + 1.5;
      }
      return false;
    },

    handleCalculateLayoutItem(i) {
      let newWidth = false;
      let index = false;
      this.layout.forEach((widget, ind) => {
        if (widget.i != i || widget.chartType !== 'TitleBoxWidget') return;
        index = ind;
        newWidth = this.calculateSizeWidget(widget);
      });
      if (newWidth === false) return;
      const layout = this.$util.deepCopy(this.layout);
      layout[index].w = newWidth;
      this.layout = layout;
    },

    resizedEvent(i) {
      this.handleCalculateLayoutItem(i);
      this.loading = false;
      this.layoutUpdatedEvent(this.layout);
    },

    movedEvent() {
      this.loading = false;
      this.layoutUpdatedEvent(this.layout);
    },

    layoutUpdated(newLayout) {
      if (this.loading) return;
      this.layoutUpdatedEvent(newLayout);
    },

    layoutUpdatedEvent(newLayout) {
      // 레이아웃 변경 이벤트 후 위젯 정보 업데이트
      if (this.dashboardActiveTab == 'my') {
        const n = this.$util.deepCopy(newLayout);
        n.forEach((widget) => {
          widget.chartAttr.x = widget.x;
          widget.chartAttr.y = widget.y;
          widget.chartAttr.w = widget.w;
          widget.chartAttr.h = widget.h;
          delete widget.x;
          delete widget.y;
          delete widget.w;
          delete widget.h;
          delete widget.i;

          const fixWidth = 172;
          const maxWidth = this.getMaxWidthOfTitle(widget.chartAttr.title);

          const w = widget.chartAttr.w;
          const line = Math.ceil(maxWidth / (fixWidth * w));
          if (line > 3 && widget.chartAttr.h == 1 && widget.chartAttr.w == 1) {
            return;
          }

          this.updateWidget(widget);
        });
      }
    },
    getListWidgets(loadingbar = false) {
      // 위젯 목록 조회
      this.getWidgetLoading = true;
      this.layout = [];
      this.$http.dashboard
        .get(`/v1/console/dashboards/${this.dashboard.dashboardId}/widgets`, false, loadingbar)
        .then((res) => {
          this.layout = res.contents.map((widget, i) => {
            widget.chartAttr = JSON.parse(widget.chartAttr);
            widget.chartAttr.subtitle = '';
            widget.x = widget.chartAttr.x;
            widget.y = widget.chartAttr.y;
            widget.w = widget.chartAttr.w;
            widget.h = widget.chartAttr.h;
            widget.chartType = widget.chartAttr.widget.type;
            widget.i = i.toString();
            return widget;
          });
          this.getWidgetLoading = false;
        });
    },
    async createWidget(config) {
      // 위젯 생성
      return await this.$http.dashboard
        .post(
          this.getWidgetUrl(config),
          {
            ...config,
            dashboardId: this.dashboard.dashboardId
          },
          false,
          false
        )
        .then((res) => {
          this.added++;
          if (this.widgetCount === this.added) {
            this.getListWidgets();
          }
          return res;
        });
    },
    async updateWidget(config, checkProduct = false) {
      // 위젯 업데이트
      config.checkProduct = checkProduct;
      return await this.$http.dashboard.put(
        `${this.getWidgetUrl(config)}/${config.chartId}`,
        config,
        false,
        false
      );
    },
    deleteWidget(config) {
      // 위젯 삭제
      this.$http.dashboard
        .delete(`${this.getWidgetUrl(config)}/${config.chartId}`, {}, false, false)
        .then(() => {
          this.layout = this.layout.filter((l) => l.chartId !== config.chartId);
        });
    },
    copyWidget(config) {
      // 위젯 복사
      this.$http.dashboard
        .post(
          `/v1/console/dashboard-widgets-without-accountId/${config.chartId}/copy`,
          {
            chartName: config.chartAttr.title,
            dashboardId: this.dashboard.dashboardId
          },
          false,
          false
        )
        .then((res) => {
          let widget = res;
          widget.chartAttr = JSON.parse(widget.chartAttr);
          widget.x = widget.chartAttr.x;
          widget.y = widget.chartAttr.y;
          widget.w = widget.chartAttr.w;
          widget.h = widget.chartAttr.h;
          widget.chartType = widget.chartAttr.widget.type;
          widget.i = this.index;
          const newLayout = cloneDeep(this.layout);
          newLayout.push(widget);
          this.layout = cloneDeep(newLayout);
          this.handleCalculateLayoutItem(widget.i);
        });
    },

    getWidgetUrl(config) {
      // TitleBox widget, 프로젝트 권한이 없는경우 without-projectId API Call
      return config.chartAttr.widget.type === 'TitleBoxWidget' || !config.isAccountAuth
        ? `/v1/console/dashboard-widgets-without-accountId`
        : `/v1/console/dashboard-widgets`;
    },
    setSearchDate() {
      // 위젯 API 검색시간 설정
      this.searchDate = this.$refs.reloadPicker.getCurrentDate();
      this.searchDate.type = 'custom-dashboard';
      this.setSearchDateDashboard(this.searchDate);
    },
    async onClickPopup(data) {
      if (!data || !data.param) return;

      const listDataCheckAuth = [
        {
          productResourceId: data.param.productId,
          productName: data.param.productName
        }
      ];
      const payload = {
        productTypeCode: data.param.productTypeCode,
        params: {
          productId: data.param.productId
        },
        listDataCheckAuth
      };

      const res = await this.$store.dispatch('authStore/checkProductDetail', payload);

      if (res.type === this.$const.AuthorizationResult.ALLOW) {
        this.monitoringModalParam = data.param;
        this.togglePopup(data.id);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.dashboard-container {
  .vue-grid-layout {
    margin: -22px;
    z-index: 0;
  }
}

.titleArea {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 60px;
  gap: 20px;
  position: relative;
  z-index: 1;

  .title {
    line-height: 32px;
    font-size: 24px;
    font-weight: 700;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: normal;
    text-align: left;
    color: var(--color-ui-13);
    // flex: 1;
  }

  .action {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    max-width: 620px;
    min-width: max-content;

    .buttonGroup {
      width: 100px;
      display: flex;
      justify-content: flex-end;
      gap: 12px;
      border-left: 1px solid #cfd2d8;

      :deep(.lego-button--border.lego-button--primary) {
        background-color: transparent;

        &:hover {
          background-color: rgba(44, 89, 217, 0.2);
        }

        .opus-icon--thick-stroke {
          stroke: #2c59d9;
        }

        svg {
          fill: #2c59d9;
        }
      }
    }
  }
}

.emptyWedget {
  width: 100%;
  height: calc(100vh - 180px);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  &--notDashboard {
    height: calc(100vh - 120px);
  }

  .noWidgetMessage {
    height: 40px;
    font-family: $lego__font-family;
    font-size: 36px;
    font-weight: 700;
    font-stretch: normal;
    font-style: normal;
    line-height: 40px;
    letter-spacing: normal;
    text-align: center;
    color: var(--color-ui-13);
    margin-top: 48px;
  }

  .makeWidgetMessage {
    height: 40px;
    margin-top: 16px;
    font-family: $lego__font-family;
    font-size: 20px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 40px;
    letter-spacing: normal;
    text-align: center;
    color: #555b68;
  }

  :deep(.lego-button--solid.lego-button--primary) {
    font-weight: 400;
    font-size: 15px;
    line-height: 16px;
    margin-top: 48px;
  }
}

:deep .lego-segment-wrapper {
  .lego-segment-button.lego-segment-button--medium {
    min-width: auto;
    width: 32px;
    height: 32px;
  }
}

.lego-dropdown-refresh {
  position: absolute;
  top: 33px;
  right: 0;
  width: 129px;
  border: solid 1px var(--blue-with-a-hint-of-purple);
  background-color: #fff;
  z-index: 100;

  & button {
    display: block;
    width: 100%;
    height: 34px;
    padding: 8px 10px;
    text-align: left;
    font-size: 13px;
    color: #1f2533;
    background-color: #fff;
    border: 0;
    outline: none;
    cursor: pointer;

    &.active,
    &:hover {
      color: rgb(54, 79, 199);
      background-color: rgba(174, 184, 233, 0.12);
    }
  }
}

:deep .lego-segment-button {
  path: {
    fill: #1f2533;
    opacity: 0.6;
  }
}

:deep .lego-segment-button--checked {
  path {
    fill: #364fc7;
  }
}

:deep .dropdown-group {
  .lego-dropdown-check-wrap + .lego-drop-holder {
    margin-left: 0 !important;
    & > div {
      display: block !important;
      min-height: 0px !important;
    }
  }
}
:deep .lego-dropdown-menu {
  border-radius: 4px !important;
  overflow: hidden;
  .lego-dropdown__items {
    background-color: transparent;
  }
}
:deep .status-metric-widget {
  .widget-header {
    height: unset !important;
    min-height: unset !important;
  }
}
</style>
